import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Version from './Constants/Version';
import { Title } from 'react-admin';

const Dashboard = () => (
  <Card>
    <Title title="Dashboard" />
    <CardContent>Future Publisher Services - Ad Management Console {Version}
    <br/><br/>
    <b>Information: </b> Publishers, sites and Hybrid placements configuration have moved to <a href="https://ad-manager.futureplc.com/">Future Ad Manager</a>
    </CardContent>
  </Card>
);

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Framework/Dashboard.tsx